import { normalizedTranslate } from '@rbilabs/components-library';
import styled from 'styled-components';

import { MenuCardButton } from 'components/menu-card-button';

export const RewardsCarouselContainer = styled.div`
  margin-block-start: -0.6rem;
`;

export const PreviousButton = styled(MenuCardButton)`
  transform: rotate(180deg) translateX(50%);

  &:active {
    transform: rotate(180deg) translateX(50%) scale(0.95);
  }
`;

export const NextButton = styled(MenuCardButton)`
  transform: ${normalizedTranslate('50%')};

  &:active {
    transform: ${normalizedTranslate('50%')} scale(0.95);
  }
`;
